export default __webpack_public_path__ + "static/media/ninjatag_LADOWANIE.7c2943b0.mp4";